import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DeblurIcon from '@mui/icons-material/Deblur';
import BlockIcon from '@mui/icons-material/Block';



const EffectsPopup = ({
    open,
    onClose,
    effects = [],
    activeFilter,
    onSelectEffect,
}) => {
    const [selectedEffect, setSelectedEffect] = useState(activeFilter || "none");

    useEffect(() => {
        setSelectedEffect(activeFilter || "none");
    }, [activeFilter]);

    const handleEffectSelect = (effect) => {
        setSelectedEffect(effect);
        if (onSelectEffect) onSelectEffect(effect);
    };

    const effectOptions = [
        { label: "No effect", value: "none", icon: <BlockIcon fontSize="large" /> },
        { label: "Light blur", value: "light-blur", icon: <BlurOnIcon fontSize="large" /> },
        { label: "Strong blur", value: "strong-blur", icon: <DeblurIcon fontSize="large" /> },
    ];

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    position: "absolute",
                    top: "100px",
                    right: "50px",
                    margin: 0,
                    borderRadius: '8px',
                },
            }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                Select an Effect
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Box display="flex" justifyContent="space-around" mb={2}>
                    {effectOptions.map((option) => (
                        <Box
                            key={option.value}
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            gap={1}
                        >
                            <Box
                                onClick={() => handleEffectSelect(option.value)}
                                sx={{
                                    width: 80,
                                    height: 80,
                                    border:
                                        selectedEffect === option.value
                                            ? "2px solid blue"
                                            : "1px solid #ccc",
                                    borderRadius: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    transition: "0.3s",
                                }}
                            >
                                {option.icon}
                            </Box>

                            <Typography variant="body2" fontWeight="bold" align="center">
                                {option.label}
                            </Typography>
                        </Box>
                    ))}
                </Box>

            </DialogContent>
        </Dialog>
    );
};

export default EffectsPopup;
